import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Subject } from "rxjs";
import { Router } from "@angular/router";




@Component({
  selector: "app-card-request-confrim-details",
  templateUrl: "./card-request-confrim-details.component.html",
  standalone:false,
  styleUrls: ["./card-request-confrim-details.component.scss"],
})
export class CardRequestConfrimDetailsComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  constructor(private location: Location, private router: Router) {}

  ngOnInit(): void {}
  showModal(num) {
    this.modalObservable.next(num);
  }
  back() {
    this.location.back();
  }
  cardRequestLimitSetting() {
    this.router.navigateByUrl("/CardRequestLimitSetting");
  }
}
